import { checkRouteForMainSections, checkRouteForFileSections } from '@/utils/nav-guards-checks';

const routes = [
  {
    path: 'decision',
    name: 'decision',
    beforeEnter: checkRouteForMainSections,
    component: () => import('@/app/file/pages/app-filing-decision'),
  },
  {
    path: 'account-info',
    name: 'account-info',
    component: () => import('@/app/file/pages/app-bank-account'),
    beforeEnter: checkRouteForMainSections,
  },
  {
    path: 'proofs',
    name: 'proofs',
    component: () => import('@/app/file/pages/app-upload-proofs'),
    beforeEnter: checkRouteForMainSections,
  },
  {
    path: 'manual',
    name: 'manual',
    component: () => import('@/app/file/pages/app-manual'),
    beforeEnter: checkRouteForMainSections,
  },
  {
    path: 'negotiation',
    name: 'negotiation',
    component: () => import('@/app/file/pages/app-negotiation-services'),
    beforeEnter: checkRouteForFileSections,
  },
  {
    path: 'manual-download',
    name: 'manual-download',
    component: () => import('@/app/file/pages/app-download-documents'),
    beforeEnter: checkRouteForFileSections,
  },
  {
    path: 'filing-status',
    name: 'filing-status',
    component: () => import('@/app/file/pages/app-filing-status'),
    beforeEnter: checkRouteForFileSections,
  },
  {
    path: 'final',
    name: 'final',
    component: () => import('@/app/file/pages/app-final'),
    beforeEnter: checkRouteForMainSections,
  },
];

export default routes;
